import * as yup from 'yup';
import { validateCNPJ } from 'validations-br';

import { AnyObject, Maybe } from 'yup/lib/types';

yup.addMethod<yup.StringSchema>(yup.string, 'cnpj', function testCnpj(errorMessage) {
  return this.test('testCnpj', errorMessage, value => !!value && validateCNPJ(value));
});

declare module 'yup' {
  interface StringSchema<TType extends Maybe<string> = string | undefined, TContext extends AnyObject = AnyObject, TOut extends TType = TType> extends yup.BaseSchema<TType, TContext, TOut> {
    cnpj(message?: string): StringSchema<TType, TContext>;
  }
}
